import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { 
  Typography, 
  TextField, 
//  MenuItem,
  Button,
  IconButton, 
} from '@material-ui/core';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import { SelectAreaGroup, SelectCompanyType } from 'components';

import { statusContracts, typesCompany } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  spacer: {
    flexGrow: 1
  },
  Button: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const CompanyToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    userRole,
    companies,
    areas,
    groups,
    onClickSearch,
    onClickOpenRegisterDialog,
    onClickOpenEditDialog,
    onClickOpenDeleteDialog,
    disableEditButton,
    disableDeleteButton,
    onClickOpenUploadDialog,
    onClickOpenDownloadDialog,
    ...rest
 } = props;

  const classes = useStyles();

  const [selectedCompany, setSelectedCompany] = useState('');

  const [selectedArea, setSelectedArea] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');

  const [selectedContract, setSelectedContract] = useState('');
  const [selectedType, setSelectedType] = useState('');

  const [areaGroups, setAreaGroups] = useState([]);

  const handleChangeArea = (e) => {
    let newAreaGroups = groups.filter(group => group.area === e.target.value);
    //console.log('new groups ->');
    //console.log(newAreaGroups);
    setAreaGroups(newAreaGroups);
    setSelectedGroup('');
    setSelectedArea(e.target.value)
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          택시회사 명
        </Typography>

        <Autocomplete
          id="company-toolbar-find-company-name-auto"
          options={companies.map(company => company.name)}
          style={{ width: 420 }}
          value={selectedCompany}
          onChange={(event, newValue) => {
            //console.log(newValue);
            setSelectedCompany(newValue);
          }}
          // onChange={event=> setSelectedCompany(event.target.value)}
          renderInput={params => (
            <TextField {...params} 
              variant="outlined" 
              fullWidth 
              margin="dense" />
          )}
        />

       <Button
        color="primary"
        variant="contained"
        onClick={ () => onClickSearch(selectedCompany, selectedArea, selectedGroup, selectedContract, selectedType) }
       >
         조회
       </Button>
       
      </div>

      <SelectAreaGroup 
        areas={areas}
        groups={areaGroups}
        valueArea={selectedArea}
        onChangeArea={handleChangeArea}
        valueGroup={selectedGroup}
        onChangeGroup={e => setSelectedGroup(e.target.value)}
        />

      <SelectCompanyType
        contracts={[{value:-1, label: '전체'}, ...statusContracts]}
        types={[{value:-1, label: '전체'}, ...typesCompany]}
        valueContract={selectedContract}
        onChangeContract={e => setSelectedContract(e.target.value)}
        valueType={selectedType}
        onChangeType={e => setSelectedType(e.target.value)}
        />

      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegisterDialog }
          >
            등록
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEditDialog }
          >
            수정
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDeleteDialog }
          >
            삭제
          </Button>

          <div className={classes.rowIcons}>
            <IconButton
              arai-label="view"
              onClick={onClickOpenUploadDialog}
            >
                <CloudUploadIcon />
            </IconButton>

            <IconButton
              arai-label="view"
              onClick={onClickOpenDownloadDialog}
            >
                <CloudDownloadIcon />
            </IconButton>
          </div>

        </div>
      )}
    </div>
  );
};

CompanyToolbar.propTypes = {
  className: PropTypes.string,
  companies: PropTypes.array.isRequired,
  areas: PropTypes.array.isRequired,
  groups: PropTypes.array.isRequired,
};

CompanyToolbar.defaultProps = {
  companies: [],
  areas: [],
  groups: [],
};

export default CompanyToolbar;
